import React from "react";
import {
    FaUser,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";


function Summary({ summaryData, onClick, setSelectedId, selectedId }) {
    const summary = [
        {
            amount: '₹' + (summaryData?.total || 0),
            label: `Total Balance`,
            color: "text-black",
            icon: <FaUser size={20} className="text-blue-400" />,
            filter: 'All',
        },
        {
            amount: '₹' + (summaryData?.givenToStaff || 0),
            label: `Staff Balance`,
            color: "text-black",
            icon: <FaUser size={20} className="teal-teal-400" />,
            filter: 'A',
        },
        {
            amount: '₹' + (summaryData?.balance || 0),
            label: `Your Wallet`,
            color: "text-black",
            icon: <FaUser size={20} className="text-green-400" />,
            filter: 'I',
        },
    ];
    return (
        <Wrapper>
            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {summary.map((item, index) => (
                    <Card $selected={selectedId === index} index={index} key={index} >
                        <ValueRow>
                            <Value color={item.color}>{item.amount}</Value>
                        </ValueRow>
                        <Label>
                            <span>
                                {item.label}

                                {item.flatCount > 0 && (
                                    <span className="text-xs text-gray-400">
                                        {" • "} {item.flatCount} Flats
                                    </span>
                                )}
                            </span>

                            <ArrowWrap className="arrow">
                                <Chevron />
                            </ArrowWrap>
                        </Label>
                    </Card>
                    // <Card key={index} onClick={() => onClick(item.filter)}>
                    //     <div>
                    //         <span className={`text-[18px] font-bold ${item.color}`}>
                    //             {item.amount}
                    //         </span>
                    //         <Label>
                    //             {item.label}
                    //             {item.icon}
                    //         </Label>
                    //     </div>
                    // </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;

const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;


const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default Summary;

